import CategoryManagementPage from "./CategoryManagementPage";
export default CategoryManagementPage;
